import { render, staticRenderFns } from "./NglControl.vue?vue&type=template&id=e423847a&scoped=true&"
import script from "./NglControl.vue?vue&type=script&lang=js&"
export * from "./NglControl.vue?vue&type=script&lang=js&"
import style0 from "./NglControl.vue?vue&type=style&index=0&id=e423847a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e423847a",
  null
  
)

export default component.exports